import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { CommonMessage } from '@frontend/lang';

/** @deprecated Use SentryErrorBoundary from @frontend/sentry instead. */
export class ErrorBoundary extends Component {
    override state = { error: null };
    constructor(props: any | Readonly<any>) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error: any) {
        return { error };
    }

    override render() {
        if (this.state.error) {
            return (
                <div className='h-dvh w-dvw flex flex-col bg-background-default'>
                    <div className='flex flex-col gap-2 w-full'>
                        <h1 className='text-brand-primary m-2 text-2xl'>Oops!</h1>
                        <div className='text-brand-secondary m-2'>
                            <p className='text-secondary'>
                                <FormattedMessage
                                    id='GlobalErrorBoundary.Explanation'
                                    description='Explanation for users that encountered a (uncaught) error.'
                                    defaultMessage='It seems like there is something wrong with the page you requested.
                            We are very sorry for the inconvenience. You can go back where you came from and try again. Or if this keeps happening, please contact us.'
                                />
                            </p>
                        </div>
                        <div className='absolute bottom-6 flex w-full flex-row items-center justify-center'>
                            <button
                                onClick={() => window.location.reload()}
                                className='bg-brand-primary inline-flex w-1/3 items-center justify-center rounded-xl px-4 py-3.5'>
                                <div className='text-base font-medium text-white'>
                                    {CommonMessage.BUTTONS.REFRESH}
                                </div>
                            </button>
                            <a
                                className='border-1 border-brand-primary inline-flex w-1/2 items-center justify-center rounded-xl px-4 py-3.5 ms-2'
                                href={`mailto:support@telloport.com?subject=Mobile%20Error&body=Please tell us about what you experienced here.%0A%0Ainfo:{href:${window.location.href}, path:${window.location.pathname}, ${this.state.error}}`}>
                                <div className='text-base font-medium text-brand-primary'>Contact support</div>
                            </a>
                        </div>
                    </div>
                </div>
            );
        }

        
        // eslint-disable-next-line react/prop-types
        return (this.props as { children: React.ReactNode }).children;
    }
}

export default ErrorBoundary;
